import type { FaireProductEntity } from "../../entity_types/product";

export const p_hqf8rvnbv5: FaireProductEntity = {
  token: "p_hqf8rvnbv5",
  type: "product",
  name: "Relaxation - Loose Leaf Herbal Tea",
  brandToken: "b_cev7opt9ab",
  brandName: "Nature's Inventory",
  imageUrl:
    "https://cdn.faire.com/fastly/60c4ac4dca469cd91d8a4e759b812c34e3aa8a60ec26da632b40370d272ff746.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.06,
  description:
    " * Organic and Wild Crafted Herbs \n * Naturally Caffeine Free \n * Promotes Non-Drowsy Relaxation \n * Loose leaf tea provides 40-60 servings \n\nPamper yourself with this wonderful, relaxing tea any time of day. The synergistic blend of herbs calm your nerves almost at your first sip! Tastes and smells heavenly. A wonderful tea to enjoy and give as a gift! ",
  tags: [],
  msrpDollars: 22.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:53.596Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
